import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";

// ────────────────────────────────────────────────────────────────────────
// i18n init.
//
// English is the only shipping locale; the LanguageDetector sits in
// front so adding another locale is a one-liner (add it to `resources`,
// nothing else). Interpolation runs through i18next's default — the
// semantic token tree in `en.json` is what the UI binds to.
// ────────────────────────────────────────────────────────────────────────

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: ["en"],
    interpolation: {
      escapeValue: false, // React already escapes string children.
    },
    detection: {
      // Honour an explicit `?lng=` first, then the cached choice, then
      // the browser preference.
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
